module.exports = __webpack_public_path__ + "static/media/showroom.8839607f.png";